import { ErrorTypes } from '../enums/errorTypes.enum';

export class ErrorMessage {
  errorType: ErrorTypes;
  message?: string;

  constructor(errorType: ErrorTypes, message?: string) {
    this.errorType = errorType;
    if (message) {
      this.message = message;
    }
  }
}
